import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-add-program',
  templateUrl: './add-program.component.html'
})
export class AddProgramComponent implements OnInit {

  addProgramForm: FormGroup | any;
  file: any;
  imageType: any;
  imageUrl: any;
  countryArr: any = [];
  IsFree: any;
  programTypeList: any;

  constructor(public service: MainService, private router: Router) { }

  ngOnInit() {
    this.addProgramFormValidation();
    this.viewProgramList();
  }

  // Add Subadmin Form Validation

  addProgramFormValidation() {
    this.addProgramForm = new FormGroup({
      'title': new FormControl('', Validators.compose([Validators.required, Validators.maxLength(256), Validators.pattern(/^[^\s][a-zA-Z ]*$/)])),
      'programType': new FormControl('', Validators.compose([Validators.required])),
      'therapistSession': new FormControl(''),
      'MedicalSession': new FormControl(''),
      'CaseManager': new FormControl(''),
      'description': new FormControl('', Validators.compose([Validators.required, Validators.maxLength(1000)])),
      'amount': new FormControl('', Validators.compose([Validators.required])),
      'isInsurancePackage': new FormControl('No')
    });

  }
  programTypeChange(value: string) {
    if (value === 'FREE') {
      this.IsFree = 'readonly';
      this.addProgramForm.patchValue({
        programType: 'FREE',
        amount: '0'
      })
    }
    else {
      this.IsFree = ''
    }
  }

  // program list api inntegration 
  viewProgramList() {
    this.service.showSpinner();
    this.service.getApi(ApiUrls.programType_list, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.programTypeList = res.result;
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }

  // Add Program Api Integration 

  addProgram() {
    // var regex = /(<([^>]+)>)/ig; 
    //  let desc =  this.addProgramForm.value.description.replace(regex, "");
    const data = {
      title: this.addProgramForm.value.title,
      programType: this.addProgramForm.value.programType,
      amount: this.addProgramForm.value.amount,
      therapist_session: this.addProgramForm.value.therapistSession || '0',
      physician_session: this.addProgramForm.value.MedicalSession || '0',
      caseManager_session: this.addProgramForm.value.CaseManager || '0',
      description: this.addProgramForm.value.description,
      is_insurance_package: this.addProgramForm.value.isInsurancePackage == 'Yes'
    }
    this.service.showSpinner()
    this.service.postApi(ApiUrls.addProgram, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.service.successToast(res.responseMessage)
        this.router.navigate(['/program-mgt'])
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }


}
